import React from 'react'
import { ScriptsIcon } from './icons'
import ResourceCardList from './ResourceCardList'
import { useTranslation } from '../../hooks/useTranslation'

export const ScriptCards = () => {
  return <ResourceCardList Comp={ScriptCard} contextPropertyName="scripts" />
}

const ScriptCard = ({ resource }) => {
  const {
    headerImageAlt,
    headerImageUrl,
    path,
    title,
    webinarAssociated,
    canView,
  } = resource

  const { t } = useTranslation('index')

  if (canView) {
    return (
      <div className="h-[112px]">
        <a
          href={path}
          target="_blank"
          rel="noreferrer"
          className="flex h-full items-center rounded-[20px] border border-[#B9B9B9] px-4 py-2 hover:!underline"
        >
          <div className="relative h-full shrink-0 overflow-hidden rounded-[20px]">
            <img
              src={
                headerImageUrl ||
                'https://www-yns-com.s3.us-east-2.amazonaws.com/images/job_search/scripts_resource_center.jpeg'
              }
              alt={headerImageAlt || ''}
              className="h-full rounded-[20px]"
            />
            {webinarAssociated && canView && (
              <div className="absolute bottom-0 left-0 right-0 bg-[#E0F2F9] px-2 py-1 text-center text-xs font-medium text-primary">
                {t('webinar_exclusive')}
              </div>
            )}
          </div>
          <div className="ml-4 flex h-full w-full flex-col justify-center">
            <ScriptsIcon className="h-8 w-8" />
            <p>{title}</p>
          </div>
        </a>
      </div>
    )
  }
}

export default ScriptCard
